<template>

<div v-if="meta.totalPages > 1" class="sd-pagination">

    <!-- Page Size -->
    <div class="sd-page-size">

        <select v-model.number="localPageSize" @change="changePageSize">

            <option v-for="size in pageSizes" :key="size" :value="size">
                {{ size }}
            </option>

        </select>

    </div>


    <!-- Prev -->
    <button
        class="sd-btn"
        :disabled="meta.pageNumber <= 1"
        @click="goToPage(meta.pageNumber - 1)"
    >
        Prev
    </button>


    <!-- First -->
    <button
        v-if="meta.pageNumber > 3"
        class="sd-btn"
        @click="goToPage(1)"
    >
        1
    </button>

    <span v-if="meta.pageNumber > 4">...</span>


    <!-- Dynamic Pages -->
    <button
        v-for="page in visiblePages"
        :key="page"
        class="sd-btn"
        :class="{ active: page === meta.pageNumber }"
        @click="goToPage(page)"
    >
        {{ page }}
    </button>


    <span v-if="meta.pageNumber < meta.totalPages - 3">...</span>


    <!-- Last -->
    <button
        v-if="meta.pageNumber < meta.totalPages - 2"
        class="sd-btn"
        @click="goToPage(meta.totalPages)"
    >
        {{ meta.totalPages }}
    </button>


    <!-- Next -->
    <button
        class="sd-btn"
        :disabled="meta.pageNumber >= meta.totalPages"
        @click="goToPage(meta.pageNumber + 1)"
    >
        Next
    </button>


    <!-- Info -->
    <span class="sd-info">

        Page {{ meta.pageNumber }}
        of {{ meta.totalPages }}
        ({{ meta.totalRecords }} records)

    </span>

</div>

</template>

<script>

export default {

    name: "BasePagination",

    props: {

        meta: {

            type: Object,

            required: true

            /*
            Expected format:

            {
                pageNumber,
                pageSize,
                totalPages,
                totalRecords
            }
            */
        },

        pageSizes: {

            type: Array,

            default: () => [5, 10, 20, 50, 100]
        }
    },

    data() {

        return {

            localPageSize: this.meta.pageSize
        };
    },

    computed: {

        visiblePages() {

            let pages = [];

            let start = Math.max(1, this.meta.pageNumber - 2);

            let end = Math.min(
                this.meta.totalPages,
                this.meta.pageNumber + 2
            );

            for (let i = start; i <= end; i++)
                pages.push(i);

            return pages;
        }
    },

    watch: {

        "meta.pageSize"(val) {

            this.localPageSize = val;
        }
    },

    methods: {

        goToPage(page) {

            if (page < 1 || page > this.meta.totalPages)
                return;

            this.$emit("page-changed", {

                pageNumber: page,

                pageSize: this.localPageSize
            });
        },


        changePageSize() {

            this.$emit("page-changed", {

                pageNumber: 1,

                pageSize: this.localPageSize
            });
        }
    }
};

</script>


<style scoped>

.sd-pagination {

    display: flex;

    flex-wrap: wrap;

    align-items: center;

    gap: 5px;

    margin-top: 20px;
}


.sd-btn {

    padding: 6px 12px;

    border: 1px solid #ddd;

    background: white;

    cursor: pointer;

    border-radius: 4px;
}


.sd-btn.active {

    background: #007bff;

    color: white;
}


.sd-btn:disabled {

    opacity: 0.5;

    cursor: not-allowed;
}


.sd-page-size select {

    padding: 5px;
}


.sd-info {

    margin-left: 10px;

    font-size: 13px;

    color: #666;
}


@media(max-width:600px){

.sd-pagination{

    justify-content:center;
}

}

</style>
